var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
    'App-galileo': _vm.$site === _vm.$const.sites.galileo,
    'App-nikon': _vm.$site === _vm.$const.sites.nikon,
    'App-nikon-it': _vm.$site === _vm.$const.sites['nikon-it']
  }},[(_vm.layout === 'embed')?_c('CreateAppointment',{attrs:{"eId":_vm.qs.eId,"origin":_vm.qs.origin,"shopUuid":_vm.qs.shopUuid}}):(_vm.layout === 'landing')?_c('Landing',{attrs:{"eId":_vm.qs.eId,"origin":_vm.qs.origin,"shopUuid":_vm.qs.shopUuid}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }